import React, { PureComponent } from 'react';

import NotFound from 'widgets/NotFound/NotFound';

export default class NotFoundPage extends PureComponent {
  render() {
    return (
      <div>
        <NotFound>
          <p>404 - Page Not Found</p>
        </NotFound>
      </div>
    );
  }
}
